import { getTrendingProductsFilters } from '~/grid/utils/cioUtils';

import {
  DESKTOP_PRODUCT_COUNT,
  MOBILE_PRODUCT_COUNT,
} from '../constants/cioConstants';

/**
 * @function getTrendingProducts
 * @description Fetch trending products using Constructor's Recommendation
 * API. Caller must handle error handling.
 * @return {Promise}
 */
export const getTrendingProducts = async ({
  cioClient,
  isVip,
  isElite,
  isSecondarySite,
  isMobile,
  isLoggedIn,
  gender,
  isScrubs,
}) => {
  const productFilters = getTrendingProductsFilters({
    isElite,
    isVip,
    shouldShowWarehouseProducts: isSecondarySite,
    isLoggedIn,
    gender,
    isScrubs,
  });

  const cioFacetResults = await cioClient.recommendations.getRecommendations(
    'trending-products',
    {
      numResults: isMobile ? MOBILE_PRODUCT_COUNT : DESKTOP_PRODUCT_COUNT,
      filters: productFilters,
    }
  );
  return {
    trendingProducts: cioFacetResults?.response?.results,
    podId: cioFacetResults?.response?.pod?.id,
    resultId: cioFacetResults?.result_id,
  };
};
